import { Grid } from "@chakra-ui/react";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import { TransactionTrendsBarChart } from "./transaction-trends-bar-chart";
import totalTransactionVolumeAndCount from "../../mocks/total-transaction-volume-and-count.json";
import authorizationRate from "../../mocks/authorization-rate.json";
import { useState } from "react";
import { StatusFilter } from "../status-filter";

export function TransactionTrends() {
  const [timeRange, setTimeRange] = useState("daily");

  const statusOptions = [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ];

  return (
    <WidgetBox title="Transaction Trends">
      <StatusFilter statuses={statusOptions} value={timeRange} onChange={setTimeRange} />
      <Grid
        templateColumns={{
          base: "1fr",
          xl: "repeat(2, 1fr)",
        }}
        gap={4}
        mt={4}
      >
        <TransactionTrendsBarChart
          title="Total Transaction Volume and Count"
          transactions={totalTransactionVolumeAndCount}
        />

        <TransactionTrendsBarChart title="Authorization Rate" transactions={authorizationRate} />
      </Grid>
    </WidgetBox>
  );
}
